/**
 * Full-screen loading state for join / invite flows — dark gradient, purple spinner.
 */

import { useMemo } from 'react';
import { ActivityIndicator, Text } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import { useTheme } from '../../theme/useTheme';
import { getJoinDeepLinkStyles } from '../../../appStyles/_joinDeepLink.styles';
import { getJoinFlowGradientColors } from '../helpers/joinFlowScreen.helper';

interface JoinFlowLoadingScreenProps {
  message?: string;
  testID?: string;
}

export function JoinFlowLoadingScreen({ message, testID }: JoinFlowLoadingScreenProps) {
  const appTheme = useTheme();
  const styles = useMemo(() => getJoinDeepLinkStyles(appTheme), [appTheme]);
  const gradient = useMemo(() => getJoinFlowGradientColors(appTheme), [appTheme]);

  return (
    <LinearGradient colors={gradient} style={styles.loadingContainer} testID={testID}>
      <ActivityIndicator size="large" color={appTheme.primary} />
      {message != null && message.length > 0 ? (
        <Text style={styles.loadingText}>{message}</Text>
      ) : null}
    </LinearGradient>
  );
}
